import React, { useState } from 'react';
import './AdminNav.css';

function AdminNav({ user, onLogout, roleColor, dashboardTitle, onMenuToggle, isCollapsed, onToggleCollapse, apiBase }) {
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleLogout = async () => {
    if (window.confirm('Anda yakin ingin logout?')) {
      try {
        // Call API logout endpoint
        const response = await fetch(`${apiBase || 'https://permataharapansecondary.sch.id/api'}/auth/logout`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' }
        });
        console.log('[AdminNav] Logout API response:', response.status);
      } catch (err) {
        console.error('[AdminNav] Logout API error:', err);
      }
      
      // Clear all auth data
      localStorage.clear();
      sessionStorage.clear();
      
      // Clear cookies by setting them to expire
      document.cookie.split(";").forEach((c) => {
        document.cookie = c
          .replace(/^ +/, "")
          .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });
      
      // Call onLogout callback
      onLogout();
      
      // Redirect to login page
      window.location.href = '/#!/login';
    }
  };

  return (
    <nav className="admin-nav">
      <div className="nav-wrapper">
        <div className="nav-brand-section">
          <button 
            className="nav-menu-toggle"
            onClick={onMenuToggle}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <div className="brand-logo">
            <div className="logo-icon">PH</div>
            <div className="brand-text">
              <div className="brand-title">Permata Harapan</div>
              <div className="brand-subtitle">{dashboardTitle}</div>
            </div>
          </div>
        </div>

        <div className="nav-center"></div>

        <div className="nav-user-menu">
          <div className="user-profile">
            <div className="user-avatar-badge">{user?.full_name?.charAt(0).toUpperCase() || 'U'}</div>
            <div className="user-details">
              <div className="user-fullname">{user?.full_name || 'Admin'}</div>
              <div className="user-role-badge">{user?.roles?.[0]?.replace('_', ' ').toUpperCase() || 'STAFF'}</div>
            </div>
          </div>

          <button 
            className="menu-btn"
            onClick={() => setShowUserMenu(!showUserMenu)}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="1" />
              <circle cx="12" cy="5" r="1" />
              <circle cx="12" cy="19" r="1" />
            </svg>
          </button>

          {showUserMenu && (
            <div className="dropdown-menu">
              <button className="menu-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                <span>Profile</span>
              </button>
              <button className="menu-item">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="1" />
                  <path d="M12 1v6m0 6v6M4.22 4.22l4.24 4.24m3.08 3.08l4.24 4.24M1 12h6m6 0h6M4.22 19.78l4.24-4.24m3.08-3.08l4.24-4.24" />
                </svg>
                <span>Settings</span>
              </button>
              <div className="menu-divider" />
              <button className="menu-item logout-item" onClick={handleLogout}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
                </svg>
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}

export default AdminNav;
